export default __webpack_public_path__ + "static/pawStamp-eece2f05e747a4547ec05c6b93271084.png";